<template>
    <v-chart  
    style="width:98%;height:250px;left:0%;"
    :auto-resize="true"
    ref="chart"/>
</template>
<script>
import { use } from "echarts/core";
import { CanvasRenderer } from "echarts/renderers";
import { BarChart,LineChart  } from "echarts/charts";
import "echarts/lib/component/markPoint";
// import ECharts from 'echarts';
import {
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent
} from "echarts/components";
import VChart, { THEME_KEY } from "vue-echarts";

use([
  CanvasRenderer,
  BarChart,
  LineChart,
  GridComponent,
  ToolboxComponent,
  TooltipComponent,
  LegendComponent,
  DataZoomSliderComponent
]);
export default {
    name:'chartstrategy',
    components:{
        VChart
    },
    provide: {
        [THEME_KEY]: "light"
    },
    created(){
        setTimeout(()=>{
            this.setoption();
        },1000)
        
    },
    mounted() {
        this.$nextTick(()=>{
            this.$refs.chart.clear();
            this.setoption();
            window.addEventListener("resize", this.resizeTheChart);
        })
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.resizeTheChart);
    },
    methods:{
        resizeTheChart() {
            if (this.$refs.chart) {
                this.$refs.chart.resize();
            }
        },
        setoption(){
            this.$refs.chart.setOption(this.option, true);
        }
    },
    props:{
       categories:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       actuals:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       maxs:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       mins:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       targets:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
       alerts:{
           type: Array,
           required: true,
           default: ()=>{
               return []
           }
       },
    },
    data(){
        return {
            option:{
                // color: ['#05478f', '#2f93fe','#bdb2ff','#bbdafc'],
                grid:{
                    left: '2%',
                    top:'10%',
                    right:'0%',
                    bottom:'25%'
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    },
                    formatter: function (params) {
                        let html=params[0].name+"<br>";
                        for(let i=0;i<params.length;i++){
                            html+='<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:'+params[i].color+';"></span>'
                            html+=params[i].seriesName+": "+"<span style='color:black'>"+params[i].value+"%</span><br>"
                            
                        }
                        if(params[0].value > params[1].value){
                            html+='<span style="color:#dc3545">Actual allocation is outside the target!</span>'
                        }
                        return html;
                    }

                },
                toolbox: {
                    itemSize:16,
                    feature: {
                        dataView: {show: false, readOnly: false},
                        magicType: {show: true, type: ['bar','stack','tile']},
                        // restore: {show: true},
                        myToolRestore: {
                            show: true,
                            title: "Restore",
                            icon:
                                "path://M512 981.333333c-209.866667 0-396.693333-126.026667-466.293333-314.08a35.52 35.52 0 0 1 23.626666-44.426666 38.613333 38.613333 0 0 1 48 20.693333c58.666667 158.933333 217.013333 265.493333 394.666667 265.6s336-106.666667 394.666667-266.133333a37.6 37.6 0 0 1 28.853333-23.626667 38.986667 38.986667 0 0 1 35.786667 11.946667 34.773333 34.773333 0 0 1 7.146666 35.36c-69.386667 188.373333-256.48 314.666667-466.453333 314.666666z m431.36-574.08a37.92 37.92 0 0 1-35.946667-24.266666C849.386667 222.56 690.613333 114.88 512 114.72S174.72 222.346667 116.746667 382.773333A38.72 38.72 0 0 1 69.333333 403.733333a35.786667 35.786667 0 0 1-24.106666-44.373333C113.333333 169.866667 301.013333 42.666667 512 42.666667s398.666667 127.306667 467.146667 316.96a34.56 34.56 0 0 1-4.906667 32.64 38.933333 38.933333 0 0 1-30.88 14.986666z",
                            onclick: () => {
                                this.$refs.chart.clear();
                                this.$refs.chart.setOption(this.option);
                            },
                        },
                        saveAsImage: {show: true},

                    }
                },
                xAxis:[
                    {
                        type: 'category',
                        data: this.categories,
                        axisLine:{
                            show: false
                        },
                        axisLabel:{
                            interval:'0',
                            formatter:function(value)  
                               {  
                                return value.split(" ").join("\n");  
                               }  
                        },
                        axisTick:{
                            show:false
                        },
                        // axisPointer: {
                        //     type: 'shadow'
                        // }
                    }
                ],
                yAxis: [
                    {
                        type: 'value',
                        axisLabel:{
                            show:false
                        }
                    },
                    
                    
                ],
                series: [
                    
                    {
                        name: 'Actual Allocation',
                        type: 'line',
                        // stack: '总量',
                        // smooth: true,
                        color:'#05478f',
                        lineStyle: {
                            width: 0
                        },
                        showSymbol: false,
                        areaStyle: {
                            opacity: 0.9,
                            color: '#05478f'
                        },
                        data: this.actuals,
                        markPoint:{
                            data: this.alerts,
                            symbolSize:25,
                            itemStyle:{
                                color:'#dc3545',
                            }
                        }
                    },
                    {
                        name: 'Target',
                        type: 'line',
                        // stack: '总量',
                        // smooth: true,
                        color: '#6930c3',
                        lineStyle: {
                            width: 1
                        },
                        // showSymbol: false,
                        areaStyle: {
                            origin: 'start',
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#6930c3' 
                                }, {
                                    offset: 1, color: 'rgba(105, 48, 195, 0.5)' 
                                }],
                                global: false 
                            }
                        },
                        // emphasis: {
                        //     focus: 'series'
                        // },
                        data: this.targets
                    },
                    {
                        name: 'Min',
                        type: 'line',
                        // stack: '总量',
                        // smooth: true,
                        color:'#bbdafc',
                        lineStyle: {
                            width: 1
                        },
                        // showSymbol: false,
                        areaStyle: {
                            origin: 'start',
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#bbdafc'
                                }, {
                                    offset: 1, color: 'rgba(187,218,252,0.5)' 
                                }],
                                global: false 
                            }
                        },
                        // emphasis: {
                        //     focus: 'series'
                        // },
                        data: this.mins
                    },
                    {
                        name: 'Max',
                        type: 'line',
                        // stack: '总量',
                        color:'#2f93fe',
                        // smooth: true,
                        lineStyle: {
                            width: 1
                        },
                        // showSymbol: false,
                        areaStyle: {
                            origin: 'start',
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [{
                                    offset: 0, color: '#2f93fe'
                                }, {
                                    offset: 1, color:'rgba(168,218,220,0.3)'
                                }],
                                global: false 
                            }
                        },
                        // emphasis: {
                        //     focus: 'series'
                        // },
                        data: this.maxs
                    },
                    
                ]
            }
        }
    }
}
</script>